module.exports = __webpack_public_path__ + "media/1-z.3b077b38.wav";